import { createCountriesTV } from "../../../models/country.model";
import { createUserTV } from "../../../models/user.model";
import { tv } from "../../../models/text-value.model";

export const createReportData = (data = {}) => {
  const invoice_projects = data.invoice_projects || [];

  const client = data.client || {};

  const countries = data.countries || [];
  const countriesTV = createCountriesTV(countries);


  const users = data.userlist || [];
  const usersTV = createUserTV(users);

  const statuses = data.statuslist || [];
  const statusesTV = statuses.map(tv(
    'booking_status_name',
    'booking_status_id'
  ));
  
  const artists = data.artistlist || [];


  return {
    ...data,
    invoice_projects,
    client,
    countries,
    countriesTV,
    users,
    usersTV,
    statuses,
    statusesTV,
    artists,
  }
}


export const BOOKING_REPORT_TYPES = {
  FINANCE_REPORT: 'finance_report',
  MONEY_DETAILS_REPORT: 'money_details_report',
  MANAGEMENT_REPORT: 'management_report',
  EXTENDED_FINANCE_REPORT: 'extended_finance_report',
};
